export default __webpack_public_path__ + "static/media/Mobile_login-bro_1[1].36d465fd.png";